import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { CorporationZoneService } from '../corporation-zone.service'

@Component({
  selector: 'app-corporation-zone-table',
  templateUrl: './corporation-zone-table.component.html',
  styleUrls: ['./corporation-zone-table.component.scss']
})
export class CorporationZoneTableComponent implements OnInit {

  displayedColumns: string[] = ['id', 'name'];
  dataSource: any;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private global: GlobalService, private http: HttpService, public corporationService : CorporationZoneService) {
    this.getCorporationZone();
    this.global.set_master_page_title = 'Corporation Zone';
    this.corporationService.downloadCorporationZone.subscribe((is_new_relation_name_present) => {
      console.log(is_new_relation_name_present);
      if (is_new_relation_name_present) {
        this.getCorporationZone();
      }
    });
   }

   registerCorporationZoneType() {
    console.log('click for register relation type')
    this.showCorporationZoneRegister();
    this.corporationService.CorporationZoneUpdate.emit(null);
    this.corporationService.set_corporation_zone_data = null;
  }


  editCorporationZone(relation_type) {
    this.showCorporationZoneRegister();
    this.corporationService.CorporationZoneUpdate.emit(relation_type);
    this.corporationService.set_corporation_zone_data = relation_type;
  }

  showCorporationZoneRegister() {
    this.corporationService.is_display_corporation_zone_register_component = true;
  }

  hideCorporationZoneRegister() {
    this.corporationService.is_display_corporation_zone_register_component = false;
  }

   getCorporationZone() {
    this.http.getCorporationZone().subscribe((data: CorporationZone[]) => {
      console.log(data);
      this.dataSource = new MatTableDataSource<CorporationZone>(data);
      this.dataSource.sort = this.sort;
    }, (error) => {
      console.log(error);
    });
   }

  ngOnInit() {
  }

}

export interface CorporationZone {
  id: number;
  name: string;
}
